module.exports = __webpack_public_path__ + "static/media/backspaceSmall.643ab92a.svg";